import { ReelReturn } from '../models';
import { useDocument } from './useDocument';

export function useReelReturn(companyId: string, id: string | 'new' = 'new') {
  return useDocument<ReelReturn>(`/Companies/${companyId}/ReelReturns`, id);
}
